import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Navigation } from '../../navigation/react-redux-nav';
import SettingsNavigation from './components/settings-navigation';
import SettingsSkip from './components/settings-skip';

import './index.css';

class SettingsContainer extends Component {
  static get propTypes() {
    return {
      children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
      forward: PropTypes.func.isRequired,
      backward: PropTypes.func.isRequired,
      save: PropTypes.func,
      mediaType: PropTypes.string,
      seeMoreIncluded: PropTypes.bool,
      hideSkip: PropTypes.bool,
      hideNavigation: PropTypes.bool,
      className: PropTypes.string,
      appName: PropTypes.string,
      pageTitle: PropTypes.string,
      subtitle: PropTypes.bool,
      page: PropTypes.string.isRequired,
      flowType: PropTypes.string.isRequired,
      isValid: PropTypes.bool
    };
  }

  moveForward = async () => {
    if (this.props.save) {
      await this.props.save();
    }
    this.props.forward();
  }

  render() {
    return (
      <div className="settings-parent">
        <SettingsSkip
          hideSkip={ this.props.hideSkip }
          moveForward={ this.props.forward }
        />
        <div className={ classNames('settings-page', this.props.className, this.props.appName, this.props.mediaType) }>
          <div className={ classNames({ 'see-more-container': this.props.seeMoreIncluded || this.props.mediaType === 'phone' }) }>
            <div className="settings-page-container">
              <header className="settings-page-header">
                <h1>{ this.props.pageTitle }</h1>
                { this.props.subtitle && <h2>Select <strong>ALL</strong> that apply.</h2> }
              </header>
              <div className="settings-page-options-container">
                { this.props.children }
              </div>
            </div>
          </div>
        </div>
        <SettingsNavigation
          hideNavigation={ this.props.hideNavigation }
          moveBackward={ this.props.backward }
          saveAndMoveForward={ this.moveForward }
          renderProgress={ this.renderProgress }
          appName={ this.props.appName }
          flowType={ this.props.flowType }
          page={ this.props.page }
          mediaType={ this.props.mediaType }
          isValid={ this.props.isValid }
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    appName: state.config.appName,
    flowType: state.navigationFlow.flowType,
    mediaType: state.config.mediaType,
    page: state.page,
  }),
  dispatch => ({
    forward: () => dispatch(Navigation.forward()),
    backward: () => dispatch(Navigation.backward()),
  })
)(SettingsContainer);
